import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoutingModule } from './user-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarModule } from 'ng-sidebar';
import { NgxPaginationModule } from 'ngx-pagination';
// import { JwPaginationModule } from 'jw-angular-pagination';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { UserEnrolledCourseComponent } from './user-enrolled-course/user-enrolled-course.component';
import { UserComponent } from './user.component';
import { ListUserComponent } from './list-user/list-user.component';
import { ViewEnrolCourseComponent } from './view-enrol-course/view-enrol-course.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { FliterUserComponent } from './fliter-user/fliter-user.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { UserReportDialogComponent } from './user-report-dialog/user-report-dialog.component';

@NgModule({
  declarations: [
    UserEnrolledCourseComponent,
    UserComponent,
    ListUserComponent,
    ViewEnrolCourseComponent,
    EditUserComponent,
    FliterUserComponent,
    UserReportDialogComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatDialogModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    NgxPaginationModule,
    // JwPaginationModule,
    SidebarModule.forRoot(),NgMultiSelectDropDownModule,
    MatNativeDateModule,
  ],
})
export class UserModule {}
